/* GONNA Our Story — shared behaviour for the split story sections.
   Runs once, handles every .gs wrapper on the page (cycling hero words,
   the name reveal, and scroll-reveal). Reduced-motion safe. */
(function () {
  if (window.__gsStoryInit) return;
  window.__gsStoryInit = true;

  function init() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Cycling hero words
    document.querySelectorAll('.gs__cycle').forEach(function (cycle) {
      var words = cycle.querySelectorAll('.gs__word');
      if (!reduce && words.length > 1) {
        var i = 0;
        setInterval(function () {
          words[i].classList.remove('is-on');
          i = (i + 1) % words.length;
          words[i].classList.add('is-on');
        }, 2200);
      }
    });

    var wrappers = document.querySelectorAll('.gs');
    if (!reduce && 'IntersectionObserver' in window) {
      wrappers.forEach(function (w) { w.classList.add('gs--anim'); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var t = en.target;
          if (t.classList.contains('gs__reveal')) {
            var sibs = Array.prototype.filter.call(t.parentNode.children, function (c) { return c.classList.contains('gs__reveal'); });
            var idx = sibs.indexOf(t);
            if (idx > 0) t.style.transitionDelay = (idx * 0.07) + 's';
          }
          t.classList.add('is-in');
          io.unobserve(t);
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('.gs__reveal, .gs__ethos-line, .gs__word-big').forEach(function (t) { io.observe(t); });
    } else {
      document.querySelectorAll('.gs__word-big').forEach(function (b) { b.classList.add('is-in'); });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
